import { Dispatch } from 'redux';
import { actionCreators } from './VersionsState';

export const resetState = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetState());
};

export const fetchNodeVersionInfo = async (
  dispatch: Dispatch<any>,
  includeDecommissioned: boolean
) => {
  return dispatch(actionCreators.fetchNodeVersionInfo(includeDecommissioned));
};

export const resetNodeVersionInfoFetchError = async (dispatch: any) => {
  return dispatch(actionCreators.resetNodeVersionInfoFetchError());
};

export const getNodeVersionPropertyValues = async (dispatch: any) => {
  return dispatch(actionCreators.getNodeVersionPropertyValues());
};
